import {Grid, Typography,IconButton,FormControlLabel,Switch,CircularProgress} from '@material-ui/core';
import LinkIcon from '@material-ui/icons/Link';
import {useEffect,useState} from 'react';
import {useDispatch} from 'react-redux';
import {useParams} from 'react-router-dom';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Accordion from '@material-ui/core/Accordion';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import {useInterval,loadSkeleton,getClusteredQuestions,getShuffledClusterColors,QUESTIONS_UTIL} from '../../utility';
import * as briefActions from '../../actions/briefActions';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';


function QuestionsBrief({briefInfo,setQuestionsClusteringSwitch,questionsClusteringSwitch,questionsClustering,clusteringLoadingState,updateContentCall, fetchReport}){
    
    const dispatch = useDispatch();
    let { id } = useParams();
    // For polling
    const pollDelay = 7000;
    const [shouldPoll, setShouldPoll] = React.useState(!(briefInfo.report && briefInfo.report.related_questions && briefInfo.report.related_questions_quora && briefInfo.report.related_questions_autocomplete));
    

    useEffect(()=> {
        if(shouldPoll){
            // If the Time passed is more than 30mins, Stop Polling and show the questions.
            if(Date.parse(new Date()) > new Date(briefInfo.created_at).setMinutes(new Date(briefInfo.created_at).getMinutes() + 30)){
                setShouldPoll(false);
            }
        }
    }, []);
    
    // Start polling for questions if they are not being generated yet.
    useInterval(() => {
        dispatch(briefActions.getBriefQuestionsStatus(id, () => {
            setShouldPoll(false);
            fetchReport().then(() => {
                updateContentCall();
            });
        }));
    }, shouldPoll ? pollDelay : null);


    const checkForQuestionsEmptyState = (briefInfo) =>{
        if(!shouldPoll && briefInfo.report && briefInfo.report.related_questions && !Array.isArray(briefInfo.report.related_questions.questions) && !Array.isArray(briefInfo.report.related_questions_quora.questions) && !Array.isArray(briefInfo.report.related_questions_autocomplete.questions)){
            return (
                <Typography>{QUESTIONS_UTIL.NO_QUESTIONS_ERROR_TEXT} "{briefInfo.report.focus_keyword}"</Typography>
            )
        }
    }

    const css = `
        .brief-questions .MuiTableCell-root{
            padding: 16px 0;
        }

        .brief-questions .MuiAccordionSummary-root, .brief-questions .MuiAccordionDetails-root{
            padding: 0;
        }

        .brief-topic-switch-label span{
            font-size: 12px !important;
        }
    `;
    
    let clusterView = false;
    let clusteredQuestions = []
    let colorSeed = (briefInfo && briefInfo.name)? briefInfo.name.length : null;
    let clusterColors = getShuffledClusterColors(colorSeed);

    if(questionsClustering && questionsClusteringSwitch){
        clusterView = true;
        clusteredQuestions = getClusteredQuestions(briefInfo)
        clusteredQuestions = _.filter(clusteredQuestions, (cq) => { return cq.length > 1 })
    }

    return(
        <Grid>
            {(shouldPoll)? 
            <Grid container xs="12"  direction="row" className="brief-questions" spacing={1} style={{padding:'1rem',backgroundColor:'white'}}>
                <Grid item xs="12" style={{marginBottom:'1rem',position:'sticky',position:'-webkit-sticky',top:'0'}}>
                <style>{css}</style>
                <Typography variant="subtitle2" display="block" style={{fontWeight:'800',color:'#334152'}}>{QUESTIONS_UTIL.HEADER}</Typography>
                <Typography variant="caption" display="block" style={{color:'#334152'}}>{QUESTIONS_UTIL.DESCRIPTION}</Typography>
                <Grid style={{margin:'1.5rem',textAlign:'center'}}>
                    <Typography variant="caption" display="block" style={{fontWeight:'500',color:'#334152'}}>{QUESTIONS_UTIL.FETCHING_QUESTIONS_MESSAGE}</Typography>
                    <CircularProgress size={24} style={{marginTop:'1rem'}} />
                </Grid>
                </Grid>
            </Grid>
            : 
            <Grid container xs="12"  direction="row" className="brief-questions" spacing={1} style={{padding:'1rem',backgroundColor:'white'}}>
                <style>{css}</style>
                <Grid item xs="12" style={{marginBottom:'1rem',position:'sticky',position:'-webkit-sticky',top:'0'}}> 
                    <Typography variant="subtitle2" display="block" style={{fontWeight:'800',color:'#334152'}}>{QUESTIONS_UTIL.HEADER}</Typography>
                    <Typography variant="caption" display="block" style={{color:'#334152'}}>{QUESTIONS_UTIL.DESCRIPTION}</Typography>
                    <FormControlLabel 
                        value="Group By Theme"
                        className="brief-topic-switch-label"
                        control={<Switch
                            color="primary"
                            checked={questionsClusteringSwitch}
                            onChange={()=>setQuestionsClusteringSwitch(!questionsClusteringSwitch)}
                            />}
                        label="Group By Theme"
                        labelPlacement="end"
                        gutterBottom
                    />
                    {clusteringLoadingState? <CircularProgress size={24} /> : null}
                </Grid>
                    {(!clusterView) ? 
                    <Grid item xs="12" alignItems="center" direction="row" style={{marginBottom:20}}>
                        {(!briefInfo.report) ? 
                            loadSkeleton('text')
                        : 
                            checkForQuestionsEmptyState(briefInfo)
                        }
                        {(briefInfo.report && briefInfo.report.related_questions && briefInfo.report.related_questions.questions && briefInfo.report.related_questions.questions.length > 0) ?
                        <Accordion square={true} style={{boxShadow:'none'}} defaultExpanded={true}>
                            <AccordionSummary
                            expandIcon={<ExpandMoreIcon />}
                            aria-controls="question-panel"
                            id="question-panel-id"
                            >
                            <Typography variant="subtitle2" display="block" style={{fontWeight:'800',color:'#334152',fontSize:'0.8rem'}}>{QUESTIONS_UTIL.GOOGLE_QUESTIONS_TEXT_HEADER}</Typography>
                            </AccordionSummary>
                            <AccordionDetails>
                                <TableContainer>
                                <Table aria-label="simple table">
                                    <TableBody>
                                    {(briefInfo.report && briefInfo.report.related_questions && Array.isArray(briefInfo.report.related_questions.questions)) ? (briefInfo.report.related_questions.questions).map((singleQuestion,index) => {
                                    return(
                                        <TableRow key={singleQuestion.keyword}>
                                            <TableCell component="th" scope="row">
                                                <Typography variant="subtitle2" style={{fontSize: '12px', color:'#3e4b5b', cursor: 'pointer'}} onClick={() => window.open(`https://www.google.com/search?q=${singleQuestion.keyword}`, "_blank")}>{singleQuestion.keyword}
                                                    <IconButton size="small" aria-label="question-link" style={{float:'right'}}>
                                                        <FontAwesomeIcon icon="external-link-alt" style={{fontSize: '12px'}} />
                                                    </IconButton>    
                                                </Typography>
                                            </TableCell>
                                        </TableRow>
                                        );
                                        }) : <TableRow><TableCell><Typography variant="subtitle2" style={{fontSize: '12px', color:'#3e4b5b'}}>No Questions Found</Typography></TableCell></TableRow>
                                        }
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            </AccordionDetails>
                        </Accordion>
                        : null
                        }
                        {(briefInfo.report && briefInfo.report.related_questions_quora && briefInfo.report.related_questions_quora.questions && briefInfo.report.related_questions_quora.questions.length > 0) ? 
                        <Accordion square={true} style={{boxShadow:'none'}} defaultExpanded={true}>
                            <AccordionSummary
                            expandIcon={<ExpandMoreIcon />}
                            aria-controls="question-panel"
                            id="question-panel-id"
                            >
                            <Typography variant="subtitle2" display="block" style={{fontWeight:'800',color:'#334152',fontSize:'0.8rem'}}>{QUESTIONS_UTIL.QUORA_QUESTIONS_TEXT_HEADER}</Typography>
                            </AccordionSummary>
                            <AccordionDetails>
                                <TableContainer>
                                <Table aria-label="simple table">
                                    <TableBody>
                                    {(briefInfo.report && briefInfo.report.related_questions_quora && Array.isArray(briefInfo.report.related_questions_quora.questions)) ? 
                                        (briefInfo.report.related_questions_quora.questions).map((singleQuestion,index) => {
                                    return(
                                        <TableRow key={singleQuestion.keyword}>
                                            <TableCell component="th" scope="row">
                                                <Typography variant="subtitle2" style={{fontSize: '12px', color:'#3e4b5b', cursor: 'pointer'}} onClick={() => window.open(`${singleQuestion.link}`, "_blank")}>{singleQuestion.question}
                                                    <IconButton size="small" aria-label="question-link" style={{float:'right'}}>
                                                        <FontAwesomeIcon icon="external-link-alt" style={{fontSize: '12px'}} />
                                                    </IconButton>
                                                </Typography>
                                            </TableCell>
                                        </TableRow>
                                        );
                                        }) : <TableRow><TableCell><Typography variant="subtitle2" style={{fontSize: '12px', color:'#3e4b5b'}}>No Questions Found</Typography></TableCell></TableRow>
                                        }
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            </AccordionDetails>
                        </Accordion>
                        : null}
                        {(briefInfo.report && briefInfo.report.related_questions_autocomplete && briefInfo.report.related_questions_autocomplete.questions && briefInfo.report.related_questions_autocomplete.questions.length > 0) ? 
                            <Accordion square={true} style={{boxShadow:'none'}} defaultExpanded={true}>
                            <AccordionSummary
                            expandIcon={<ExpandMoreIcon />}
                            aria-controls="question-panel"
                            id="question-panel-id"
                            >
                            <Typography variant="subtitle2" display="block" style={{fontWeight:'800',color:'#334152',fontSize:'0.8rem'}}>{QUESTIONS_UTIL.AUTOCOMPLETE_QUESTIONS_TEXT_HEADER}</Typography>
                            </AccordionSummary>
                            <AccordionDetails>
                                <TableContainer>
                                <Table aria-label="simple table">
                                    <TableBody>
                                    {(briefInfo.report && briefInfo.report.related_questions_autocomplete && Array.isArray(briefInfo.report.related_questions_autocomplete.questions)) ? 
                                        (briefInfo.report.related_questions_autocomplete.questions).map((singleQuestion,index) => {
                                    return(
                                        <TableRow key={singleQuestion.keyword}>
                                            <TableCell component="th" scope="row">
                                                <Typography variant="subtitle2" style={{fontSize: '12px', color:'#3e4b5b', cursor: 'pointer'}} onClick={() => window.open(`https://www.google.com/search?q=${singleQuestion.keyword}`, "_blank")}>{singleQuestion.keyword}?
                                                    <IconButton size="small" aria-label="question-link" style={{float:'right'}}>
                                                        <FontAwesomeIcon icon="external-link-alt" style={{fontSize: '12px'}} />
                                                    </IconButton>
                                                </Typography>
                                            </TableCell>
                                        </TableRow>
                                        );
                                    }) : <TableRow><TableCell><Typography variant="subtitle2" style={{fontSize: '12px', color:'#3e4b5b'}}>No Questions Found</Typography></TableCell></TableRow>
                                            }
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            </AccordionDetails>
                        </Accordion>
                        : null }
                </Grid> : 
                <Grid item xs="12" alignItems="center" direction="row" style={{marginBottom:20}}>
                    {_.map(clusteredQuestions, (cluster, i) => {
                        let clusterColor = clusterColors[i % clusterColors.length];
                        return (
                            <div style={{borderLeft: (clusterColor? `5px solid ${clusterColor}` : 'unset'), backgroundColor: '#80808014',marginBottom: '1rem',paddingTop: '0.5rem',paddingBottom: '0.2rem'}}>
                                { _.map(cluster, (question, i) => {
                                    return (
                                        <p style={{color:'#334152',fontWeight: (i == 0)? 800 : 'unset', marginLeft:10}}>{question.keyword}</p>
                                    )
                                })}
                            </div>
                        ) 
                    })}
                </Grid>
                }
            </Grid>
            }
        </Grid>
    );

}

export default QuestionsBrief;